import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';

export const dateFormatter = new Intl.DateTimeFormat('ru-RU', {
  dateStyle: 'medium',
  timeStyle: 'short',
});

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) {return '—';}
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : dateFormatter.format(d);
}

export function formatCurrency(amount: number | string | null | undefined, currency?: string): string {
  if (amount === null || amount === undefined) {return '—';}
  const formatted = new Intl.NumberFormat('ru-RU').format(Number(amount));
  return currency ? `${formatted} ${currency}` : formatted;
}

export function FieldRow({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="space-y-0.5">
      <dt className="text-[11px] font-medium text-muted-foreground">{label}</dt>
      <dd className="text-sm font-medium">{children}</dd>
    </div>
  );
}

export function FieldGrid({ children }: { children: React.ReactNode }) {
  return (
    <dl className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
      {children}
    </dl>
  );
}

export function Section({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="rounded-lg border border-border bg-card p-3 space-y-2">
      <h2 className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">{label}</h2>
      <Separator />
      {children}
    </div>
  );
}

export function StatusBadge({ active, activeLabel = 'Активен', inactiveLabel = 'Неактивен' }: {
  active: boolean;
  activeLabel?: string;
  inactiveLabel?: string;
}) {
  return (
    <Badge variant={active ? 'default' : 'secondary'}>
      {active ? activeLabel : inactiveLabel}
    </Badge>
  );
}

export function EmptyValue() {
  return <span className="text-muted-foreground">—</span>;
}

export function MonoValue({ children }: { children: React.ReactNode }) {
  return <span className="font-mono text-sm">{children}</span>;
}

export function LinkValue({ onClick, children }: { onClick: () => void; children: React.ReactNode }) {
  return (
    <button
      type="button"
      className="text-primary hover:underline text-sm font-medium cursor-pointer"
      onClick={onClick}
    >
      {children}
    </button>
  );
}
